/* LAFRAPPE — interactions du thème.
   Le panier est celui de Shopify : ce script ne gère que l'affichage
   (sélection de pack, tiroirs, galerie, age gate, quantités). */

const FRANCO = 65;
const DUREE = 320;
const COURBE = 'cubic-bezier(0.16, 1, 0.3, 1)';

const eur = (v) =>
  v.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '\u00a0€';

/* --------------------------------------------------- affichage du prix */

/* Le prix retenu se lit à quatre endroits : sous le titre, dans le bouton
   d'ajout, dans l'économie réalisée et dans le message de livraison. Les
   quatre sont mis à jour ensemble — sinon la fiche affiche deux montants
   différents selon l'endroit où l'œil se pose. */
function refleter({ total, gain }) {
  const sousTitre = document.querySelector('[data-head-price]');
  const prixAtc = document.querySelector('[data-atc-price]');
  const economie = document.querySelector('[data-gain-value]');
  const livraison = document.querySelector('[data-ship]');

  if (sousTitre) sousTitre.textContent = eur(total);
  if (prixAtc) prixAtc.textContent = eur(total);
  if (economie && Number.isFinite(gain)) economie.textContent = eur(gain);

  if (livraison) {
    const manque = FRANCO - total;
    livraison.innerHTML = manque > 0
      ? `Plus que <strong>${eur(manque)}</strong> pour la livraison offerte`
      : `<strong>Livraison offerte</strong> sur cette commande`;
  }
}

/* ------------------------------------------------------------ packs */

function initPacks() {
  const zone = document.getElementById('packs');
  if (!zone) return;

  const packs = Array.from(zone.querySelectorAll('.pack'));
  const sobre = matchMedia('(prefers-reduced-motion: reduce)').matches;

  const glisser = (tiroir, de, vers) => {
    if (!tiroir || sobre) return;
    tiroir.animate({ height: [de, vers] }, { duration: 300, easing: COURBE });
  };

  const choisir = (pack) => {
    const avant = zone.querySelector('.pack.is-on');
    if (avant === pack) return;

    if (avant) {
      const t = avant.querySelector('.pack__drawer');
      if (t) glisser(t, `${t.scrollHeight}px`, '0px');
      avant.classList.remove('is-on');
    }

    pack.classList.add('is-on');
    const radio = pack.querySelector('input[type=radio]');
    if (radio) radio.checked = true;

    const t = pack.querySelector('.pack__drawer');
    if (t) glisser(t, '0px', `${t.scrollHeight}px`);

    refleter({ total: Number(pack.dataset.total), gain: Number(pack.dataset.gain) });
  };

  packs.forEach((pack) => {
    const radio = pack.querySelector('input[type=radio]');
    if (radio) radio.addEventListener('change', () => choisir(pack));
  });

  // état initial : le pack pré-coché pilote les montants affichés
  const actif = zone.querySelector('.pack.is-on');
  if (actif) {
    refleter({ total: Number(actif.dataset.total), gain: Number(actif.dataset.gain) });
  }
}

/* --------------------------------------------- grille simple (vapes) */

function initGrille() {
  const zone = document.querySelector('[data-weights]');
  if (!zone) return;

  const cible = document.querySelector('[data-variante-cible]');
  const boutons = Array.from(zone.querySelectorAll('.weight'));

  boutons.forEach((bouton) => {
    bouton.addEventListener('click', () => {
      boutons.forEach((b) => b.setAttribute('aria-pressed', String(b === bouton)));
      if (cible) cible.value = bouton.dataset.variante;
      refleter({ total: Number(bouton.dataset.total) });
    });
  });

  // état initial : sans ça le message de livraison resterait figé sur la
  // valeur rendue par Liquid, même après un changement de format.
  const choisi = boutons.find((b) => b.getAttribute('aria-pressed') === 'true') || boutons[0];
  if (choisi) refleter({ total: Number(choisi.dataset.total) });
}

/* ----------------------------------------------------------- tiroirs */

/* <details> ne transitionne pas sa hauteur. L'animation est faite à la
   main, et le basculement d'état est programmé plutôt que suspendu à la
   fin de l'animation : dans un onglet en arrière-plan elle ne se termine
   jamais et le tiroir resterait bloqué. */
function initTiroirs() {
  const sobre = matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('.drawer').forEach((tiroir) => {
    const bouton = tiroir.querySelector('.drawer__trigger');
    const panneau = tiroir.querySelector('.drawer__panel');
    const interieur = tiroir.querySelector('.drawer__inner');
    if (!bouton || !panneau || !interieur) return;

    let anim = null;
    let attente = null;

    const glisser = (de, vers) => {
      if (sobre) return;
      if (anim) anim.cancel();
      anim = panneau.animate({ height: [de, vers] }, { duration: DUREE, easing: COURBE });
    };

    const programmer = (action) => {
      clearTimeout(attente);
      attente = setTimeout(() => { panneau.style.height = ''; action(); }, DUREE);
    };

    bouton.addEventListener('click', (event) => {
      event.preventDefault();
      if (sobre) { tiroir.open = !tiroir.open; return; }

      if (tiroir.open) {
        glisser(`${interieur.getBoundingClientRect().height}px`, '0px');
        programmer(() => { tiroir.open = false; });
      } else {
        clearTimeout(attente);
        tiroir.open = true;
        requestAnimationFrame(() => {
          glisser('0px', `${interieur.getBoundingClientRect().height}px`);
          programmer(() => {});
        });
      }
    });
  });
}

/* ----------------------------------------------------------- galerie */

function initGalerie() {
  const principale = document.querySelector('.pdp__main img');
  const vignettes = document.querySelectorAll('.pdp__thumb');
  if (!principale || !vignettes.length) return;

  vignettes.forEach((vignette) => {
    vignette.addEventListener('click', (event) => {
      event.preventDefault();
      vignettes.forEach((v) => v.setAttribute('aria-current', String(v === vignette)));
      if (vignette.dataset.vignette) principale.src = vignette.dataset.vignette;
    });
  });
}

/* ------------------------------------------------------------ panier */

function initQuantites() {
  document.querySelectorAll('[data-qty]').forEach((bouton) => {
    bouton.addEventListener('click', () => {
      const ligne = bouton.dataset.ligne;
      const champ = document.querySelector(`[data-champ-qte="${ligne}"]`);
      if (!champ) return;
      const suivant = Math.max(0, Number(champ.value) + Number(bouton.dataset.qty));
      champ.value = suivant;
      bouton.closest('form').submit();
    });
  });
}

/* ---------------------------------------------------------- age gate */

function initAgeGate() {
  const gate = document.getElementById('agegate');
  if (!gate) return;
  if (new URLSearchParams(location.search).get('preview') === '1') return;
  if (sessionStorage.getItem('age-ok') === '1') return;

  gate.hidden = false;
  gate.querySelector('[data-age="yes"]').addEventListener('click', () => {
    sessionStorage.setItem('age-ok', '1');
    gate.hidden = true;
  });
  gate.querySelector('[data-age="no"]').addEventListener('click', () => {
    location.href = 'https://www.google.fr';
  });
}

initPacks();
initGrille();
initTiroirs();
initGalerie();
initQuantites();
initAgeGate();

/* ------------------------------------------------- navigation mobile */

/* Sous 1000 px la barre .nav est masquée : ce tiroir est le seul accès
   aux gammes. L'ouverture est purement CSS (transform + opacity), le JS
   ne fait que basculer une classe, verrouiller le fond et piéger le focus. */
function initNavMobile() {
  const tiroir = document.querySelector('[data-tiroir-nav]');
  const burger = document.querySelector('[data-burger]');
  if (!tiroir || !burger) return;

  const panneau = tiroir.querySelector('.tiroir-nav__panneau');
  const fond = tiroir.querySelector('[data-tiroir-fond]');
  const fermeture = tiroir.querySelector('[data-tiroir-fermer]');
  if (!panneau) return;

  const FOCUSABLES = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';
  let dernierFocus = null;

  const estOuvert = () => tiroir.classList.contains('is-on');

  const auClavier = (event) => {
    if (event.key === 'Escape') {
      event.preventDefault();
      fermer();
      return;
    }
    if (event.key !== 'Tab') return;

    const cibles = Array.from(panneau.querySelectorAll(FOCUSABLES));
    if (!cibles.length) return;

    const premier = cibles[0];
    const dernier = cibles[cibles.length - 1];

    if (!panneau.contains(document.activeElement)) {
      event.preventDefault();
      premier.focus();
    } else if (event.shiftKey && document.activeElement === premier) {
      event.preventDefault();
      dernier.focus();
    } else if (!event.shiftKey && document.activeElement === dernier) {
      event.preventDefault();
      premier.focus();
    }
  };

  const ouvrir = () => {
    if (estOuvert()) return;
    dernierFocus = document.activeElement;
    tiroir.classList.add('is-on');
    burger.setAttribute('aria-expanded', 'true');
    burger.setAttribute('aria-label', 'Fermer le menu');
    document.body.classList.add('nav-ouverte');
    document.addEventListener('keydown', auClavier);
    (fermeture || panneau).focus();
  };

  function fermer() {
    if (!estOuvert()) return;
    tiroir.classList.remove('is-on');
    burger.setAttribute('aria-expanded', 'false');
    burger.setAttribute('aria-label', 'Ouvrir le menu');
    document.body.classList.remove('nav-ouverte');
    document.removeEventListener('keydown', auClavier);
    // Un clic souris laisse parfois le focus sur <body> : dans ce cas le
    // rendre au burger, sinon le focus repartirait du haut du document.
    const utilisable = dernierFocus
      && dernierFocus !== document.body
      && document.contains(dernierFocus);
    (utilisable ? dernierFocus : burger).focus();
  }

  burger.addEventListener('click', () => { estOuvert() ? fermer() : ouvrir(); });
  if (fond) fond.addEventListener('click', fermer);
  if (fermeture) fermeture.addEventListener('click', fermer);

  // Un lien vers l'ancre de la page courante ne recharge rien : on ferme.
  panneau.querySelectorAll('a[href]').forEach((lien) => {
    lien.addEventListener('click', fermer);
  });

  // Passage en desktop la nav revient : sinon le fond resterait verrouillé.
  const large = matchMedia('(min-width: 1001px)');
  large.addEventListener('change', (e) => { if (e.matches) fermer(); });
}

initNavMobile();
